import { Component, OnInit } from "@angular/core";
import { AccountService } from "../../models/account.service";

@Component({
  selector: "ab-error-quota-used-alert",
  templateUrl: "./error-quota-used.component.html",
})
export class ErrorQuotaUsedAlertComponent implements OnInit {
  public daysRemaining: number;
  public show: boolean;

  constructor(private accountService: AccountService) {}

  public ngOnInit() {
    this.accountService.properties().subscribe((props: any) => {
      this.show = props.alerts.error_quota_used_alert === true;
      this.daysRemaining = props.account.error_quota_days_remaining;
    });
  }
}
